import React, { useEffect, useState } from "react";

// components
import MaterialTable from 'material-table';
import { table_translate } from "constants/MaterialTable.js";
import { Spinner } from "reactstrap";


export default function LogsAlteracaoDre({ list_table, tipoDre }) {

    const [showLoading, setshowLoading] = useState(false);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <MaterialTable style={{ minHeight: "auto" }}
                title=""
                columns={[
                    { title: 'DRE', field: 'dre' },
                    { title: 'Regional', field: 'regional' },
                    { title: 'Grupo Economico', field: 'grupoEconomico' },
                    { title: 'Loja', field: 'loja', hidden: tipoDre != "mensal" },
                    { title: 'Campo', field: 'campo' },
                    { title: 'Usuário', field: 'usuario' },
                    { title: 'Valor Antigo', field: 'valorAntigo' },
                    { title: 'Valor Novo', field: 'valorNovo' },
                    { title: 'Data/Hora', field: 'dataHora' },
                ]}
                data={list_table}
                isLoading={false}
                localization={table_translate}
                options={{
                    filtering: false,
                    search: false,
                    showTitle: false,
                    exportButton: false,
                    toolbar: false,
                    paging: false,
                    headerStyle: {
                        fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                        fontWeight: '700',
                        color: '#fff',
                        backgroundColor: "#0b3d86",
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        zIndex: 0
                    },
                }}
            />
        </>
    );
}